import styled from "@emotion/styled";

import { fontPlayfairDisplay } from "shared/lib/styles";

import { BaseImage } from "scmp-app/components/common/base-image";
import { EntityLink } from "scmp-app/components/entity-link";

import LatestStoriesIcon from "./icon-latest-stories.svg";

export const StyledBaseImage = styled(BaseImage)`
  inline-size: unset;
  block-size: 14px;
`;

export const StyledEntityLink = styled(EntityLink)`
  position: relative;
`;

export const SectionNameText = styled.div`
  color: #222222;
  font-weight: 400;
  font-size: 18px;
  font-family: ${fontPlayfairDisplay};
  line-height: 18px;
  letter-spacing: -0.01em;
  white-space: nowrap;
  text-transform: uppercase;

  &::before {
    content: "// ";
  }
`;

export const LatestStory = styled(LatestStoriesIcon)`
  block-size: 14px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 35px;
  align-items: center;
`;
